import script from "./AIChatBox.vue?vue&type=script&setup=true&lang=js"
export * from "./AIChatBox.vue?vue&type=script&setup=true&lang=js"

import "./AIChatBox.vue?vue&type=style&index=0&id=f3b2f80a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3b2f80a"]])

export default __exports__